import { AtomEffect } from 'recoil';

function onInit(key: string, fn: (value: string) => void) {
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    fn(savedValue);
  }
}

function onSetFn(key: string, newValue: string | null, isReset: boolean) {
  isReset || !newValue ? localStorage.removeItem(key) : localStorage.setItem(key, newValue);
}

export function localStorageEffect(key: string): AtomEffect<string | null> {
  return ({ setSelf, onSet }) => {
    onInit(key, setSelf);

    onSet((newValue, _, isReset) => {
      return onSetFn(key, newValue, isReset);
    });
  };
}

export function localStorageEffectNumber(key: string): AtomEffect<number | null> {
  return ({ setSelf, onSet }) => {
    onInit(key, (savedValue) => setSelf(Number(savedValue)));

    onSet((newValue, _, isReset) => onSetFn(key, String(newValue), isReset));
  };
}
